module.exports = __webpack_public_path__ + "img/coral-city-poster.54a00398.jpg";